"use strict";

exports.__esModule = true;
exports["default"] = MedCta;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function MedCta(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.382 17.292H5.45a1.32 1.32 0 1 0 0-2.64H1.382a1.32 1.32 0 0 0-1.319 1.32c0 .73.587 1.32 1.319 1.32zm26.029.007H11.639a1.33 1.33 0 0 1-1.329-1.327c0-.73.597-1.327 1.329-1.327h15.772L21.64 8.881a1.326 1.326 0 0 1 1.877-1.873l8.037 8.029c.111.121.212.263.278.43a1.286 1.286 0 0 1 0 1.019 1.54 1.54 0 0 1-.278.428l-8.08 8.071a1.315 1.315 0 0 1-.94.397c-.344 0-.682-.134-.937-.397a1.322 1.322 0 0 1 0-1.872l5.814-5.814z"
  }));
}